import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
// import Autocomplete, {
// 	createFilterOptions
// } from "@mui/material/lab/Autocomplete";
// import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import DeleteIcon from "@mui/icons-material/Delete";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { countries } from "../../utils/countriesDropdown";
import { adminCreateCurrencyMapping } from "../../redux/actions/adminCreateCurrencyMappingAction";
import { adminGetCurrencyMapping } from "../../redux/actions/adminGetCurrencyMappingAction";
import { adminDeleteCurrencyMapping } from "../../redux/actions/adminDeleteCurrencyMappingAction";
import BackButton from "../../components/BackButton/BackButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { adminCurrencyCode } from "../../redux/actions/adminCurrencyCodeAction";
import val from "../../getThemeDetails";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function AdminCurrencyMapping() {
	const [searchWalletOwnerID, setSearchWalletOwnerID] = useState("");

	const [deleteCurrencyMapping, setDeleteCurrencyMapping] = useState("");

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [Open, setOpen] = React.useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
	const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);

	const [createCurrencyStatus, setCreateCurrencyStatus] = useState(false);
	const [createCurrencyArray, setCreateCurrencyArray] = useState([]);

	const [getCurrencyStatus, setGetCurrencyStatus] = useState(false);
	const [getCurrencyArray, setGetCurrencyArray] = useState([]);

	const [deleteCurrencyStatus, setDeleteCurrencyStatus] = useState(false);
	const [deleteCurrencyArray, setDeleteCurrencyArray] = useState([]);

	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [user, setUser] = useState({
		walletOwnerID: "",
		currency: "",
		country: "",
		isDefault: ""
	});

	const { walletOwnerID, currency, country, isDefault } = user;

	const onInputChange = (e) => {
		// console.log("COUNTRIESS", countries)
		// let allCountry = [];
		// if (e.target.name == "country" && e.target.value == "All") {
		// 	let countriesS = [].concat(countries)
		// 	console.log("COUNTRIESS123", countriesS)

		// 	for (let i = 0; i < countries.length; i++) {
		// 		allCountry.push(countries[i].label)
		// 	}
		// 	setUser({ ...user, [e.target.name]: allCountry })
		// }
		// else {

		setUser({ ...user, [e.target.name]: e.target.value });
		// }
	};

	useEffect(() => {
		const adminCurrReq = {
			loginDetails: {
				adminId: regenerateTokenRes.data.partnerId
			}
		}
		dispatch(adminCurrencyCode(adminCurrReq, authToken));
	}, [authToken]);

	const adminCurrencyCodes = useSelector(({ adminCurrencyCode }) => adminCurrencyCode);

	const getWalletOwnerIdRes = useSelector(
		({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
	);

	const createCurrencyMappingRes = useSelector(
		({ adminCreateCurrencyMapping }) => adminCreateCurrencyMapping
	);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const getCurrencyMappingRes = useSelector(
		({ adminGetCurrencyMapping }) => adminGetCurrencyMapping
	);

	const deleteCurrencyMappingRes = useSelector(
		({ adminDeleteCurrencyMapping }) => adminDeleteCurrencyMapping
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		setUser({
			walletOwnerID: "",
			currency: "",
			country: "",
			isDefault: ""
		});
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "searchWalletOwnerID") {
			setSearchWalletOwnerID(value);
		}
	};

	const getWalletOwnerIdStatusFunc = () => {
		if (getWalletOwnerIdStatus) {
			if (getWalletOwnerIdRes.data.status == "success") {
				setGetWalletOwnerIdResArray(
					[].concat(getWalletOwnerIdRes.data.ownerList)
				);
			}
			if (getWalletOwnerIdRes.data.status == "failed") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getWalletOwnerIdRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerIdRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getWalletOwnerIdRes.data.status == "Failed") {
				setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
				if (
					getWalletOwnerIdRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerIdRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getWalletOwnerIdAndNameListReq = () => {
		setGetWalletOwnerIdStatus(true);
		dispatch(
			getWalletOwnerIdAndNameList(
				{
					loginDetails: {
						adminId: regenerateTokenRes.data.partnerId
					}
				},
				authToken
			)
		);
	};

	// useEffect(() => {
	// 	getWalletOwnerIdAndNameListReq();
	// }, []);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getWalletOwnerIdAndNameListReq();
			getCurrencyMappingReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	useEffect(() => {
		getWalletOwnerIdStatusFunc();
	}, [getWalletOwnerIdRes.data.status]);

	const createCurrencyMappingReq = () => {
		setCreateCurrencyStatus(true);
		let req = {
			walletOwnerId: walletOwnerID,
			currencyName: currency,
			isDefault: isDefault,
			countryList: user.country
		};
		// console.log("REQUESTTTTT", req)
		dispatch(adminCreateCurrencyMapping(req, authToken));
	};

	const createCurrencyMappingFunc = () => {
		if (createCurrencyStatus) {
			if (createCurrencyMappingRes.data.status == "success") {
				setCreateCurrencyArray(createCurrencyMappingRes.data);
				setNotificationOpen(true);
				getCurrencyMappingReq();
			}
		}
		if (createCurrencyStatus) {
			if (createCurrencyMappingRes.data.status == "failed") {
				setCreateCurrencyArray(createCurrencyMappingRes.data);
				setNotificationOpen(true);
				if (
					createCurrencyMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createCurrencyMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (createCurrencyMappingRes.data.status == "Failed") {
				setCreateCurrencyArray(createCurrencyMappingRes.data);
				setNotificationOpen(true);
				if (
					createCurrencyMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createCurrencyMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		createCurrencyMappingFunc();
	}, [createCurrencyMappingRes.data.status]);

	const getCurrencyMappingReq = () => {
		setIsLoading(true);
		setGetCurrencyStatus(true);
		let req = {
			// adminId: 2,
			adminId: val.adminIDS,
			
			walletOwnerId:
				searchWalletOwnerID == "Select Owner Id" ? "" : searchWalletOwnerID
		};
		dispatch(adminGetCurrencyMapping(req, authToken));
	};

	const getCurrencyMappingFunc = () => {
		if (getCurrencyStatus) {
			setIsLoading(false);
			if (getCurrencyMappingRes.data.status == "success") {
				setGetCurrencyArray(
					[].concat(getCurrencyMappingRes.data.currencyDetailsResponseVoList)
				);
			}
			if (getCurrencyMappingRes.data.status == "failed") {
				setGetCurrencyArray(getCurrencyMappingRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getCurrencyMappingRes.data.description ||
					getCurrencyMappingRes.description
				);
				if (
					getCurrencyMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getCurrencyMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getCurrencyMappingRes.data.status == "Failed") {
				setGetCurrencyArray(getCurrencyMappingRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getCurrencyMappingRes.data.description ||
					getCurrencyMappingRes.description
				);
				if (
					getCurrencyMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getCurrencyMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getCurrencyMappingRes.data.status == "INVALID REQUEST") {
				setGetCurrencyArray(getCurrencyMappingRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getCurrencyMappingRes.data.description ||
					getCurrencyMappingRes.description
				);
			}
			if (getCurrencyMappingRes.data.status == "NOT FOUND") {
				setGetCurrencyArray(getCurrencyMappingRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getCurrencyMappingRes.data.description ||
					getCurrencyMappingRes.description
				);
			}
		}
	};

	useEffect(() => {
		getCurrencyMappingFunc();
	}, [getCurrencyMappingRes.data.status]);

	const deleteCurrencyMappingSet = (id) => {
		setDeleteCurrencyMapping(id);
		setOpen(true);
	};

	const deleteCurrencyMappingReq = () => {
		setDeleteCurrencyStatus(true);
		setOpen(false);
		let req = {
			mappingId: deleteCurrencyMapping
		};
		dispatch(adminDeleteCurrencyMapping(req, authToken));
	};

	const deleteCurrencyMappingFunc = () => {
		if (deleteCurrencyStatus) {
			if (deleteCurrencyMappingRes.data.status == "success") {
				setDeleteCurrencyArray(deleteCurrencyMappingRes.data);
				setNotificationOpen(true);
				getCurrencyMappingReq();
			}
			if (deleteCurrencyMappingRes.data.status == "failed") {
				setDeleteCurrencyArray(deleteCurrencyMappingRes.data);
				setNotificationOpen(true);
				if (
					deleteCurrencyMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					deleteCurrencyMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (deleteCurrencyMappingRes.data.status == "Failed") {
				setDeleteCurrencyArray(deleteCurrencyMappingRes.data);
				setNotificationOpen(true);
				if (
					deleteCurrencyMappingRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					deleteCurrencyMappingRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		deleteCurrencyMappingFunc();
	}, [deleteCurrencyMappingRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setDeleteCurrencyMapping("");
		setOpen(false);
	};

	const filterOptions = createFilterOptions({
		matchFrom: "any",
		limit: 500
	});

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<DialogTitle>Create Mapping Currency</DialogTitle>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								variant="standard"
								fullWidth={true}
								name="walletOwnerID"
								value={walletOwnerID || "Select Owner Id"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Select Owner Id" selected="Select Owner Id">
									Select Owner Id
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Currency"
								fullWidth={true}
								variant="standard"

								name="currency"
								value={currency || "Select Currency"}
								onChange={onInputChange}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyCodes.success &&
									[]
										.concat(adminCurrencyCodes.data.currencyList)
										.map((x) => <MenuItem value={x.substring(x.indexOf('-') + 1)}>{x.substring(x.indexOf('-') + 1)}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[{ label: "ALL", dial_code: "", code: "" }].concat(countries)}
								getOptionLabel={(option) => option.label}
								filterOptions={filterOptions}
								renderInput={(params) => (

									<TextField
										required
										margin="dense"
										id="name"
										size="small"
										color="primary"
										type="text"
										label="Country"
										style={{ marginTop: "0" }}
										{...params}
										fullWidth={true}
										name="country"

										value={country || ""}
										onBlur={onInputChange}
									></TextField>
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Is Default"
								variant="standard"

								fullWidth={true}
								name="isDefault"
								value={isDefault || "Select Is Default"}
								onChange={onInputChange}
							>
								<MenuItem value="Select Is Default" selected="All">
									Select Is Default
								</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<div style={{ width: "100%", textAlign: "end", padding: "8px" }}>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								variant="contained"
								onClick={createCurrencyMappingReq}
							>
								Create
							</Button>
						</div>
					</Grid>
				</Card>

				<Card>
					<DialogTitle>Search</DialogTitle>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Owner ID"
								fullWidth={true}
								variant="standard"
								name="searchWalletOwnerID"
								value={searchWalletOwnerID || "Select Owner Id"}
								onChange={handleChange}
							>
								<MenuItem value="Select Owner Id" selected="Select Owner Id">
									Select Owner Id
								</MenuItem>
								{getWalletOwnerIdRes.data.ownerList &&
									getWalletOwnerIdResArray.map((x) => (
										<MenuItem value={x.split("-")[0]}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								variant="contained"
								onClick={getCurrencyMappingReq}
							>
								Search
							</Button>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getCurrencyArray.length == undefined ||
					getCurrencyArray.status == "NOT FOUND" ||
					!getCurrencyStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Currency Mapping List
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Currency Mapping List
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Mapping ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Owner Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Is Default
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Creation Date
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getCurrencyArray &&
											[]
												.concat(getCurrencyArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">
															{row.currencyId}
														</TableCell>
														<TableCell align="center">{row.daily}</TableCell>
														<TableCell align="center">{row.weekly}</TableCell>
														<TableCell align="center">
															{row.currencyName}
														</TableCell>
														<TableCell align="center">{row.monthly}</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() =>
																	deleteCurrencyMappingSet(row.currencyId)
																}
															>
																<DeleteIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getCurrencyArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}

				<div>
					<Dialog open={Open} onClose={handleClose}>
						<DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
						<DialogActions className="p-3">
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={deleteCurrencyMappingReq}
							>
								Yes
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{createCurrencyArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createCurrencyArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{createCurrencyArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{createCurrencyArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteCurrencyArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteCurrencyArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{deleteCurrencyArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{deleteCurrencyArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default AdminCurrencyMapping;
